define( function() {
	return [];
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/deletedIds.js
// module id = 182
// module chunks = 1